import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    placement: { type: String, default: 'top' },
    trigger: { type: String, default: 'hover focus' },
    delay: { type: Number, default: 0 }
  }

  connect() {
    // Allow data-bs-placement to override data-tooltip-placement-value
    const placement = this.element.dataset.bsPlacement || this.placementValue
    
    this.tooltip = new bootstrap.Tooltip(this.element, {
      placement,
      trigger: this.triggerValue,
      delay: this.delayValue
    })
  }

  disconnect() {
    if (this.tooltip) {
      this.tooltip.dispose()
      this.tooltip = null
    }
  }
}
